<!-- <div class="login-container border-radius-10 z-1 position-relative w-100 p-4 container mt-5">
  <div class="text-center mb-4">
    <h1 class="fs-3 fw-bold text-black">Welcome Back</h1>
    <p class="text-black-50">Enter your Mobile Number to continue</p>
  </div>

  <div class="d-flex justify-content-between align-items-center mb-1">
    <div class="font-gray fw-semibold fs-14">Mobile Number</div>
    <div>
      <button *ngIf="isOtpSent" type="button" class="btn btn-primary px-2 text-decoration-none" (click)="editNumber()">
        <small>Edit Number</small>
      </button>
    </div>
  </div>
  <div class="position-relative">
    <input
      id="username"
      type="text"
      maxlength="10"
      [(ngModel)]="UserMobileNo"
      (ngModelChange)="onMobileChange()"
      (keypress)="allowOnlyNumbers($event)"
      placeholder="Enter your mobile number"
      autocomplete="username"
      [disabled]="isOtpSent"
      [class.bg-light]="isOtpSent"
      required
      class="form-input w-100 fs-14 border-radius-10 p-3" />
  </div>

  <div class="mb-2 mt-2" *ngIf="!isOtpSent">
    <button type="button" class="btn btn-primary w-100" id="sendOtpBtn" (click)="sendOtp()" [disabled]="UserMobileNo.length !== 10" [class.opacity-50]="UserMobileNo.length !== 10">Send OTP</button>
  </div>

  <div class="otp-section mt-1">
    <div class="form-group">
      <label for="otp" class="font-gray fw-semibold mb-1 fs-14 mb-1">Enter OTP</label>
      <div class="position-relative">
        <input type="text" id="otp" class="form-input w-100 fs-14 border-radius-10 p-3" [(ngModel)]="OTP" placeholder="Enter 6-digit OTP" maxlength="6" required />
      </div>
    </div>

    <button type="submit" class="btn btn-primary mt-4" id="verifyBtn" (click)="onLogin()" [disabled]="OTP.length !== 6">Verify & Continue</button>
  </div>
</div> -->

<div class="login-container">
  <div class="row g-0">
    <div class="col-lg-4 d-flex flex-column">
      <!-- <div class="w-100">
        <svg class="logo" width="130" height="35" viewBox="0 0 150 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <text x="35" y="28" font-family="Poppins, sans-serif" font-size="24" font-weight="600" fill="white">SPARTAN</text>
          <path d="M25.75 10.9167L22.9167 13.75L20.0833 10.9167L15.25 15.75V25.25L22.9167 30L30.5833 25.25V15.75L25.75 10.9167Z" stroke="#C7362B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M20.0833 10.9167L22.9167 13.75L25.75 10.9167" stroke="#C7362B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M22.9167 30V13.75" stroke="#C7362B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div> -->
      <div class="d-flex justify-content-between align-items-center">
        <div class="mt-4"><img src="public/Group 1000011930.png" alt="" /></div>
        <!-- <button class="btn btn-primary mt-5 me-3" (click)="onInquiryForm()">Inquiry Form</button> -->
        <div
          [innerHTML]="SVG_ICONS.INQUIRY_FORM_ICON() | sanitizer : 'html'"
          class="mt-5 me-3 cursor-pointer"
          (click)="onInquiryForm()"
          matTooltip="Inquiry Form"
          matTooltipPosition="below"
          matTooltipShowDelay="0"></div>
      </div>

      <div class="login-form-wrapper">
        <div>
          <div class="fs-40 fw-medium font-white">Welcome!</div>
          <div class="font-gray fs-14">Please login with the registered mobile number</div>
          <form class="mt-4" *ngIf="!isOtpSent">
            <div class="form-group mb-3">
              <label class="font-white fs-14 mb-1" for="mobileNumber">Mobile Number</label>
              <div class="input-group">
                <span class="input-group-text">
                  +91
                  <i class="fas fa-chevron-down ms-2"></i>
                </span>
                <input type="tel" id="mobileNumber" class="form-control" placeholder="Enter Mobile Number" [(ngModel)]="UserMobileNo" name="mobileNumber" maxlength="10" />
              </div>
            </div>
            <button class="btn btn-brand w-100" [disabled]="!UserMobileNo || UserMobileNo.length !== 10" (click)="sendOtp()">Send OTP</button>
          </form>
        </div>

        <div *ngIf="isOtpSent">
          <div class="fs-14 font-red-light mb-4 d-flex gap-1">
            <div class="fs-14 fw-bold mt-2">+91 {{ UserMobileNo }}</div>
            <button (click)="editNumber()" [innerHtml]="SVG_ICONS.EDIT_MOBILENO_ICON() | sanitizer : 'html'" class="" style="background-color: transparent; border: none"></button>
          </div>
          <div class="form-group mb-4">
            <label class="font-white fs-14 mb-1" for="otp">OTP</label>
            <app-otp-input [length]="6" (completed)="onOtpComplete($event)"></app-otp-input>
          </div>
          <button class="btn btn-brand w-100" (click)="onLogin()">Submit</button>
          <p class="resend-text mt-4">Didn't receive OTP? <a href="javascript:void(0)" (click)="sendOtp()">Resend</a></p>
        </div>
      </div>

      <div class="login-footer">
        <a href="#">Terms of use</a>
        <span class="mx-2">&#8226;</span>
        <a href="#">Privacy Policy</a>
      </div>
    </div>

    <div class="col-lg-8 d-lg-block">
      <img src="public/pexels-pavel-danilyuk-6295989 1.png" alt="Two people boxing in a gym" />
    </div>
  </div>
</div>
